$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // ========================
  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search Website');
  $('.searchBoxInput input').val('');
  $('.mobile-menu-container .search-container').attr('placeholder', 'Search Website');
  $('#mobileSearchInput').val('');

  // ========================
  $('#generalSponsors').prepend('<h2 class="sponsors-title>Sponsors and <span>Partners</span></h2>')
  $(window).load(function () {
    $('.header .navMobileMenuShiftedGoBack').remove();
    $('#generalSponsors .homepageh1').remove();
  })
});
